import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ListType } from '@models/list-type';
import { AvailabilityInquiryState } from '@models/availability-inquiry';
import { Subcontractor } from '@models/subcontractor';
import { safeSessionStorage } from '@common/safe-storage';

@Component({
  selector: 'app-subcontractor',
  templateUrl: './subcontractor.component.html',
  styleUrls: ['./subcontractor.component.scss']
})
export class SubcontractorComponent implements OnInit {
  subcontractor: Subcontractor = new Subcontractor();
  path: string;

  availabilityInquiryState: number = AvailabilityInquiryState.Submitted;
  listState: number = ListType.Ongoing;

  AvailabilityInquiryState = AvailabilityInquiryState;
  ListType = ListType;

  constructor(
    public route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {
    this.path = this.router.url;
    this.subcontractor.id = +this.route.snapshot.paramMap.get(
      'subcontractorId'
    );

    this.availabilityInquiryState = safeSessionStorage.getItem('availabilityInquiryState') ?
      +safeSessionStorage.getItem('availabilityInquiryState') : AvailabilityInquiryState.Submitted;
    this.listState = safeSessionStorage.getItem('listState') ?
      +safeSessionStorage.getItem('listState') : ListType.Ongoing;
  }

  changeAvailabilityInquiryState(state: AvailabilityInquiryState) {
    this.availabilityInquiryState = state;
    safeSessionStorage.setItem('availabilityInquiryState', this.availabilityInquiryState.toString());
  }

  changeListState(state: ListType) {
    this.listState = state;
    safeSessionStorage.setItem('listState', this.listState.toString());
  }
}
